import React, { createContext, useContext, useState } from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';

const AlertContext = createContext({
  filtersActiveSubmenu: null,
  setFiltersActiveSubmenu: () => {},
});

export const AlertProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const add = (newMessage) => {
    const id = String(Math.random()).slice(2);
    const date = DateTime.now();
    setMessages((currentMessages) => [
      { date, id, ...newMessage },
      ...currentMessages,
    ]);
  };

  const addMultiple = (newMessages) => {
    newMessages.forEach((newMessage) => add(newMessage));
  };

  const clear = (uuid) => {
    setMessages((currentMessages) =>
      currentMessages.filter((message) => message.uuid !== uuid),
    );
  };

  const clearAll = () => {
    setMessages([]);
  };

  return (
    <AlertContext.Provider
      value={{
        add,
        addMultiple,
        clear,
        clearAll,
        messages,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export const useAlerts = () => useContext(AlertContext);

AlertProvider.propTypes = {
  children: PropTypes.node,
};
